export default __webpack_public_path__ + "static/gift-cards-hover-17548e52980713a47f30a11ff2705f21.png";